import PropTypes from "prop-types"
import { FormHelperText, FormLabel, Grid } from "@mui/material"
import { InputCheckbox } from "components/fields"
import { useFormContext } from "react-hook-form"

// Cases "Vous êtes intéressé par" ; l'erreur de groupe est portée par errorField
const Programmes = ({ errorField = 'lead.programmes', programmes, required = true }) => {
  const { control, formState: { errors } } = useFormContext()
  const errorMessage = errorField.split('.').reduce((acc, key) => acc?.[key], errors)?.message

  return (
    <Grid item xs={12}>
      <FormLabel component="legend" required={required}>Vous êtes intéressé par :</FormLabel>
      {programmes.map(programme => (
        <div key={programme.name}>
          <InputCheckbox control={control} name={programme.name} label={programme.label} />
        </div>
      ))}
      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </Grid>
  )
}

Programmes.propTypes = {
  errorField: PropTypes.string,
  programmes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  required: PropTypes.bool
}

export default Programmes
